var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThemeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34466"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.429688,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.929688,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 9.5,
    stroke: "#A8A8A8",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.107 30.6734C42.8064 30.5983 42.5058 30.6734 42.2428 30.8613C41.2659 31.6879 40.1386 32.3643 38.8987 32.8152C37.7338 33.2661 36.4563 33.4915 35.1036 33.4915C32.0601 33.4915 29.2795 32.2516 27.2881 30.2601C25.2966 28.2686 24.0566 25.4881 24.0566 22.4446C24.0566 21.167 24.2821 19.9271 24.6578 18.7998C25.0712 17.5974 25.6723 16.5078 26.4614 15.5684C26.7996 15.1551 26.7244 14.5539 26.3111 14.2157C26.0481 14.0278 25.7475 13.9527 25.4469 14.0278C22.253 14.892 19.4725 16.8084 17.4811 19.3634C15.5647 21.8809 14.4375 24.9996 14.4375 28.3814C14.4375 32.477 16.0908 36.1969 18.7962 38.9023C21.5016 41.6077 25.1839 43.261 29.3171 43.261C32.774 43.261 35.9678 42.0586 38.5229 40.0671C41.1156 38.0381 42.9943 35.1448 43.7834 31.8382C43.9337 31.3122 43.6331 30.7862 43.107 30.6734Z",
    fill: "#ACACAC"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeIcon);
export default __webpack_public_path__ + "static/media/theme_icon.375d24e953c797380f765a044b2ac29a.svg";
export { ForwardRef as ReactComponent };